<template>
  <div>
    <feed-manager-search
      tableType="feeds"
      @search="handleFeedSearch"
      v-on="$listeners"
    />
    <template v-if="filteredFeeds.length && !showLoader">
      <custom-table
        table-type="feeds"
        :columns="columns"
        :records="filteredFeeds"
        :actions="actions"
        @edit="handleEdit"
        @schedule="handleSchedule"
        @delete="handleDelete"
        @clickedRow="$emit('clickedRow', $event)"
        v-on="$listeners"
      />
    </template>
    <custom-table-state
      v-else
      table-type="feeds"
      :loading="showLoader"
      :state="emptyStateType"
    />
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import { CustomTable, CustomTableState } from '@/components/customTable'
import FeedManagerSearch from '@/components/FeedManagerSearch.vue'
import { formatDate, orderByDescending } from '@/utils/date'
import { decodeName } from '@/utils/nameValidation'
import { getSourceName } from '../utils/feedMapper'

export default {
  name: 'FeedsTable',
  components: {
    FeedManagerSearch,
    CustomTable,
    CustomTableState,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    actions: {
      type: Array,
      default: () => [],
    },
    records: {
      type: Array,
      default: () => [],
    },
    showLoader: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      searchQuery: '',
    }
  },
  computed: {
    mappedFeeds() {
      return this.records
        .reduce((acc, current) => {
          if (current.is_config_notebook) {
            const feed = {
              id: current.id,
              name: decodeName(current.name),
              source:
                getSourceName(
                  current.notebook_parameters?.investment_object_type
                ) ?? current.notebook_parameters?.investment_object_type,
              lastUpdate: formatDate(current.last_update),
              owner: current.user_id,
              notebook_parameters: current.notebook_parameters,
              notebook_id: current.notebook_id,
            }
            acc.push(feed)
          }
          return acc
        }, [])
        .sort((a, b) => orderByDescending(a.lastUpdate, b.lastUpdate))
    },
    filteredFeeds() {
      const { searchQuery, mappedFeeds } = this
      if (searchQuery) {
        return mappedFeeds.filter((item) =>
          searchQuery
            .toLowerCase()
            .split(' ')
            .every((v) => {
              return item.name.toLowerCase().includes(v)
            })
        )
      }
      return mappedFeeds
    },
    emptyStateType() {
      if (isEmpty(this.mappedFeeds) && isEmpty(this.filteredFeeds)) {
        return 'empty'
      }

      return 'notFound'
    },
  },
  methods: {
    handleFeedSearch(e) {
      this.searchQuery = e
    },
    handleSchedule(event) {
      const [id, scheduleEvent] = event
      // This is to prevent the flyover opening when we click on the Schedule button
      scheduleEvent.stopPropagation()
      this.$emit('scheduleFeed', id)
    },
    handleEdit({ id }) {
      this.$emit('editFeed', id)
    },
    handleDelete({ id }) {
      this.$emit('deleteFeed', id)
    },
  },
}
</script>

<style lang="scss" scoped>
.feed-manager__empty-state {
  margin: 0 auto;
}
</style>
